import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import './../styles/App.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar"> 
      <div className="containera">
        <div className="logo-container">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="Webcrux Technology" className="logo-image" />
          </Link>
        </div>

        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={location.pathname === '/' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            Home
          </Link>
          <Link
            to="/services"
            className={location.pathname === '/services' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            Services
          </Link>
          <Link
            to="/career"
            className={location.pathname === '/career' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            Career
          </Link>
          <Link
            to="/portfolio"
            className={location.pathname === '/portfolio' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            Portfolio
          </Link>
          <Link
            to="/about"
            className={location.pathname === '/about' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            About Us
          </Link>
          <Link
            to="/contact"
            className={location.pathname === '/contact' ? 'active' : ''}
            onClick={closeMenu}
            style={{ marginTop: window.innerWidth >= 768 ? "0.3rem" : "0" }}
          >
            Contact Us
          </Link>
          <Link
            to="/quote"
            className={`quote-button ${location.pathname === '/quote' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Quote
          </Link>
        </div>

        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;